<div class="component">
  <div class="cl-2">
    <div class="cl-1 rw-3 left-section">
      <div class="content-card" *ngFor="let p of projects.left; index as i; first as isFirst">
        <h3 class="card-title">{{p.name}}</h3>
        <div class="project-body-left">
          <img src="{{p.img}}" class="project-thumb" alt="" srcset="" width="64" height="64">
          <div class="project-content">
            <p>{{p.description}}</p>
            <button type="button" class="bt-m bt-blue" (click)="goToUrl(p.github)">
              <i class="fab fa-github"></i> View code
            </button>
            <button type="button" class="bt-m bt-blue" (click)="goToUrl(p.view)">
              <i class="fas fa-eye"></i> View Live
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="cl-1 rw-3 right-section">
      <div class="content-card" *ngFor="let p of projects.right; index as i; first as isFirst">
        <h3 class="card-title">{{p.name}}</h3>
        <div class="project-body-right">
          <div class="project-content">
            <p>{{p.description}}</p>
            <button type="button" class="bt-m bt-blue" (click)="goToUrl(p.github)">
              <i class="fab fa-github"></i> View code
            </button>
            <button type="button" class="bt-m bt-blue" (click)="goToUrl(p.view)">
              <i class="fas fa-eye"></i> View Live
            </button>
          </div>
          <img src="{{p.img}}" class="project-thumb" alt="" srcset="">
        </div>
      </div>
    </div>
  </div>
</div>

